import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

export const hostColorSelectRowStyles: SxProps<Theme> = {
	display: 'flex',
	flexFlow: 'row wrap',
	alignItems: 'center',
	gap: '8px',
};

export const hostColorSelectItemStyles = (background: string, isSelected?: boolean): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',

	width: '32px',
	height: '32px',
	borderRadius: '50%',
	boxSizing: 'border-box',

	cursor: 'pointer',

	background,
	outline: isSelected ? '2px solid white' : 'none',
});
